import React from 'react';
import { Send, Loader, AlertCircle, X } from 'lucide-react';

const ChatInput = ({
  inputMessage,
  onInputChange,
  onSendMessage,
  onKeyPress,
  isTyping,
  connectionStatus,
  apiError,
  onClearError,
  activeFilters,
  onClearFilters,
  onFilterChange,
}) => {
  return (
    <div className="border-t border-gray-200 bg-white p-3">
      <div className="max-w-6xl mx-auto px-6">
        {apiError && (
          <div className="mb-2 p-2 bg-red-50 border border-red-200 flex items-center text-red-800 text-sm">
            <AlertCircle size={16} className="mr-2 flex-shrink-0" />
            <span className="flex-1">{apiError}</span>
            <button
              onClick={onClearError}
              className="ml-2 text-red-600 hover:text-red-800"
            >
              <X size={14} />
            </button>
          </div>
        )}

        {/* Active Filters Display */}
        {activeFilters.length > 0 && (
          <div className="mb-2 p-2 bg-gray-50 border border-gray-300">
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm text-gray-900">
                Active Filters ({activeFilters.length})
              </span>
              <button
                onClick={onClearFilters}
                className="text-xs text-gray-600 hover:text-black"
              >
                Clear all
              </button>
            </div>
            <div className="flex flex-wrap gap-1">
              {activeFilters.map(([key, value]) => (
                <span
                  key={key}
                  className="inline-flex items-center gap-1 bg-electric-blue text-white text-xs px-2 py-1"
                >
                  {key.replace(/_/g, " ")}: {value}
                  <button
                    onClick={() => onFilterChange(key, "")}
                    className="text-gray-300 hover:text-white"
                  >
                    <X size={12} />
                  </button>
                </span>
              ))}
            </div>
          </div>
        )}

        <div className="flex gap-3">
          <textarea
            value={inputMessage}
            onChange={(e) => onInputChange(e.target.value)}
            onKeyPress={onKeyPress}
            placeholder="Ask"
            className="flex-1 border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-electric-blue resize-none text-black"
            rows="1"
            disabled={isTyping || connectionStatus === "error"}
          />
          <button
            onClick={() => onSendMessage()}
            disabled={
              !inputMessage.trim() ||
              isTyping ||
              connectionStatus === "error"
            }
            className="bg-electric-blue text-white px-4 py-2 hover:bg-electric-blue-eb3 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex-shrink-0"
          >
            {isTyping ? (
              <Loader size={18} className="animate-spin" />
            ) : (
              <Send className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;
